import { createSlice } from "@reduxjs/toolkit";
import { initialCommonSliceStateProps } from "../../../types/login";

const initialState: initialCommonSliceStateProps = {
  mobileDrawer: false,
};
const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setMobileDrawer: (state, action) => {
      state.mobileDrawer = action.payload;
    },
  },
});
export default commonSlice.reducer;
export const { setMobileDrawer } = commonSlice.actions;
